/**
 * BagFast — Announcement Bar
 * Rotates through announcement slides every 3 seconds.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  var slides = bar.querySelectorAll('[data-announcement-slide]');
  if (slides.length < 2) return;

  var current = 0;
  var interval = parseInt(bar.getAttribute('data-interval'), 10) || 3000;

  function showSlide(index) {
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
  }

  function next() {
    current = (current + 1) % slides.length;
    showSlide(current);
  }

  /* Start rotation */
  showSlide(0);
  setInterval(next, interval);
})();
